// extracted by mini-css-extract-plugin
module.exports = {"mCurated":"Sh","flipped":"Th","mainContentContainer":"Uh","cta":"Vh","mainContentCtaDefault":"Wh","disabled":"Xh","mainContentCtaWhite":"Yh"};